import api from '@/api/index.js'

const account_inspection_events = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_INSPECTION_EVENTS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_INSPECTION_EVENTS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_ACCOUNT_INSPECTION_EVENTS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadAccountInspectionEvents({commit}, query) {
      commit('SET_ACCOUNT_INSPECTION_EVENTS_ERROR', null)
      commit('SET_ACCOUNT_INSPECTION_EVENTS_LOADING', true);
      return api.get(`accounts/${query.id}/inspection-events?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_INSPECTION_EVENTS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_INSPECTION_EVENTS_LOADING', false);
          commit('SET_ACCOUNT_INSPECTION_EVENTS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
        })
    }
  }
}

export default account_inspection_events
